module.exports = __webpack_public_path__ + "img/26-wrangler.60e1fb39.jpg";